<div class="testimonial">
  <!--Avatar-->
  @if (image()) {
    <div class="avatar mx-auto">
      <frontend-media-image
        [classes]="'rounded-circle z-depth-1 img-fluid'"
        [image]="image()"
        [transformations]="'w_300/'"
      ></frontend-media-image>
    </div>
  }
  <!--Content-->
  @if (originator) {
    <h4 class="font-weight-bold dark-grey-text mt-4">{{originator}}</h4>
  }
  @if (originator_description) {
    <h6 class="font-weight-bold grey-text my-3">{{originator_description}}</h6>
  }
  <p class="font-weight-normal dark-grey-text">
    <i class="fa-solid fa-quote-left"></i>
    <!-- <mdb-icon fas icon="quote-left" class="pr-2"></mdb-icon> -->
  {{quotationText}}</p>
  <!--Review-->
  @if (source) {
    <div class="cyan-text">
      {{source}}
    </div>
  }
</div>